import { render } from "./leads-dashboard.vue?vue&type=template&id=42ce1a9d"
import script from "./leads-dashboard.vue?vue&type=script&lang=js"
export * from "./leads-dashboard.vue?vue&type=script&lang=js"

import "./leads-dashboard.vue?vue&type=style&index=0&id=42ce1a9d&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__